import { useState, useEffect } from "react";
import {fetchWithTimeout} from "../utils/fetchWithTimeout";
import Config from "../pages/Config";

export function usePincodeSearch(pin) {
  const [PincodeFound, setPincodeFound] = useState(false);
  const [PincodeState, setPincodeState] = useState(null);
  const [PincodeDistrict, setPincodeDistrict] = useState(null);
  const [PinSearchLoading, setLoading] = useState(true);

  useEffect(()=>{
    if(!Config.pincodeValidation) {
      setPincodeFound(true);
      setLoading(false);
      return;
    }
    if(!pin || pin.length !== 6) return;
    const getPin = sessionStorage.getItem("pincode");
    if(getPin) {
      const obj = JSON.parse(getPin);
      if(obj.pincode === pin) {
        setPincodeFound(obj.delivery);
        setPincodeState(obj.state || null);
        setPincodeDistrict(obj.district || null);
        setLoading(false);
        return;
      };
    }
    let isActive = true;
    setLoading(true);

    const PincodeFinder = async () =>{
      try{
        const res = await fetchWithTimeout(`${Config.NodePath}/api/pincode?pin=${pin}`, {}, 4000);
        if(!isActive) return;
        const result = await res.json();
        if(result?.Status==="Success") {
          const office = result.data;
          if(office.state) {
            setPincodeFound(true);
            sessionStorage.setItem("pincode",
              JSON.stringify(
                {pincode: pin,
                  state: office.state,
                  district: office.district,
                  delivery: office.serviceable
                }
              )
            );
            setPincodeState(office.state || null);
            setPincodeDistrict(office.district || null);
          }
          else setPincodeFound(false);
        }
      }
      catch(err){
        if(err.name === "AbortError") {
          console.log("Request time out");
          setLoading(false);
          setPincodeFound(false);
          setPincodeState(null);
          setPincodeDistrict(null);
        }
        else console.error(err);
      }
      finally{
        setLoading(false);
      }
    }
    PincodeFinder();
    return ()=>{
      isActive = false;
    }
  }, [pin]);
  return {PincodeFound, PincodeState, PincodeDistrict, PinSearchLoading};
}